
import { fetchUtils } from 'react-admin';
import simpleRestProvider from 'ra-data-simple-rest';

const httpClient = (url, options = {}) => {
    if (!options.headers) {
        options.headers = new Headers({ Accept: 'application/json' });
    }
    options.credentials = 'include'
    return fetchUtils.fetchJson(url, options);
};

// https://marmelab.com/react-admin/DataProviders.html#extending-a-data-provider-example-of-file-upload
const DataProvider = simpleRestProvider(window.location.origin + '/api', httpClient);

export default DataProvider